import React from 'react';
import { Icon } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import __ from "lodash";

const styles = (theme) => ({
  truckSeparator: {
    color:theme.palette.primary.main, 
    fontSize: 8,
  },
  separator: {
    minWidth: 10
  },
});

const BuildTruckRoutesFromLegs = (props) => {
  const  classes = props.classes;
  const truckLegs = __.filter(props.legs, {transportType: 'TRUCK'});
  return (<>{truckLegs.map((leg, i) => (<>{i>0?<span className={classes.separator}>&nbsp;</span>:<></>}<span><span>{leg.originAirportCode}</span><Icon className={classes.truckSeparator}>local_shipping</Icon><span>{leg.destinationAirportCode}</span></span></>))}</>);
}

export default withStyles(styles) (BuildTruckRoutesFromLegs);